module.exports = {"pt-BR":{"properties":{"apartment":{"boxes-details":{"floor":{"zero":"andar térreo","one":"1º andar","other":"%{count}º andar"}}}}}}